import React from 'react';
import '../styles/Floor.css';
import { Top } from '../assets/icons';
import { colour } from '../styles/GlobalStyles';

// Mirrors Ceiling.js — green-jade banner saying "Price floor" with a
// downward chevron icon. Reuses the Top icon flipped 180° via the
// floor-element-title-icon CSS class so we don't ship a separate asset.
function Floor(props) {
    return (
        <div className="floor-element-container bg-colour-jade-01">
            <div className="floor-element-title-container">
                <Top
                    className="floor-element-title-icon"
                    fill={colour.jade03}
                />
                <span className="body-bold colour-jade-03">
                    Price floor
                </span>
            </div>
        </div>
    )
};

export default Floor;
